module.exports = __webpack_public_path__ + "static/img/img-tx1.b021c717.png";